import { Copyright } from '../components';


function HNotFoundome() {
  return (
    <div className="App">
      <header className="App-header">
        <p>
          Page <code>NotFound</code>
        </p>
      </header>

      <Copyright/>

    </div>
  );
}

export default HNotFoundome;
